import { Image } from "@chakra-ui/react"
export default function SiteLogo(){
    return (
        <>
          <Image src="https://www.engagebay.com/new/assets/img/engagebay-logo.svg" h='30px' w='200px' />
        </>
    )
}